import { AbstractControl } from '@angular/forms';

export function BudgetEgenFinansieringRequired(
  rowId: string,
  totalKostnader: number,
) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const totalFinansiering =
        parsedValue.length > 0
          ? parsedValue.map((a) => a.value).reduce((a, b) => a + b)
          : 0;

      if (totalKostnader - totalFinansiering < 0) {
        return { [`BudgetEgenFinansieringRequired_${rowId}`]: true };
      }
    }
  };
}
